<template>
  <v-card class="ma-0 pa-0 d-block">
    <div>
      <apexchart
        type="heatmap"
        :options="chartOptions"
        :series="series"
        height="400"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
/**
 * ColumnChart
 * @description Apex heatmap chart
 *
 */

export default {
  name: "ReportsHeatMapChart",
  props: {
    /**
     * @type {{name: string,type: string,dateLabel: string,title: string,values: {categories: array,series: array,}}}
     */
    chart: {
      required: true,
      type: Object,
    },
  },
  computed: {
    chartOptions: function () {
      return {
        chart: {
          type: "heatmap",
          height: "400",
        },
        // colors: this.chart.values.colors
        //   ? this.chart.values.colors
        //   : ["#7e04b7"],
        // colors: this.chart.values.colors
        //   ? this.chart.values.colors
        //   : [
        //       "#8C5E58",
        //       "#A93F55",
        //       "#BAFF29",
        //       "#46AF78",
        //       "#F3B415",
        //       "#F27036",
        //       "#2176FF",
        //     ],
        dataLabels: {
          // enabled: true,
          formatter: function (val) {
            return val || "";
          },
          style: {
            fontFamily: "Poppins, Helvetica, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            colors: [
              function (opt) {
                // console.log(
                //   "valuee",
                //   opt.series[opt.seriesIndex][opt.dataPointIndex]
                // );
                const value = parseInt(
                  opt.series[opt.seriesIndex][opt.dataPointIndex]
                );
                const darkThreshold = 5; // customize based on your color scale
                // const isDark = value >= darkThreshold;

                // set color per cell (not global)
                if (value <= 5) {
                  return "#333133";
                } else if (value > 5 && value <= 10) return "#1e1d1e";
                else if (value > 10 && value <= 20) return "#544c54";
                else return "#efeeee";

                // return [
                //   "#333133",
                //   "#eeebeb",
                //   "#e1e0e1",
                //   "#eeedee",
                //   "#F3F0F0FF",
                //   "#ffffff",
                // ];
              },
            ],
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [
                {
                  from: 1,
                  to: 2,
                  name: "low",
                  color: "#e1b9f5",
                },
                {
                  from: 3,
                  to: 5,
                  name: "medium",
                  color: "#d497ef",
                },
                {
                  from: 6,
                  to: 10,
                  name: "high",
                  color: "#b97dde",
                },
                {
                  from: 11,
                  to: 20,
                  name: "extreme",
                  color: "#b448e8",
                },
                {
                  from: 21,
                  to: 50,
                  name: "extreme",
                  color: "#8a149b",
                },
                {
                  from: 51,
                  to: 100,
                  name: "extreme",
                  color: "#590865",
                },
              ],
            },
          },
        },
        xaxis: {
          categories: this.chart.values.x_categories,
          tickPlacement: "on",
          labels: {
            rotate: 0,
            style: { colors: "#555", fontSize: "12px", fontWeight: 600 },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#555",
              fontSize: "12px",
              fontWeight: 600,
            },
          },
        },
      };
    },
    series: function () {
      let result = this.chart.values.series.map((element) => {
        return {
          name: element.name,
          data: element.data.map((item) => item.y),
        };
      });
      return result;
    },
  },
};
</script>
